import { render, staticRenderFns } from "./MostrarContrato.vue?vue&type=template&id=20769792&scoped=true&"
import script from "./MostrarContrato.vue?vue&type=script&lang=js&"
export * from "./MostrarContrato.vue?vue&type=script&lang=js&"
import style0 from "./MostrarContrato.vue?vue&type=style&index=0&id=20769792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20769792",
  null
  
)

component.options.__file = "MostrarContrato.vue"
export default component.exports